// extracted by mini-css-extract-plugin
export default {"noLabel":"AuditionRecordingDetailsForm_noLabel__I9xqe"};